import React from 'react';
import { Authenticator as AWSAuthenticator } from 'aws-amplify-react';
import {
  SignIn,
  ConfirmSignIn,
  RequireNewPassword,
  ForgotPassword,
  ForgotPasswordReset,
  Loading,
} from './index';
import config from '../../config';
import './Authenticator.css';

/*
 * This custom Authenticator component uses the built-in AWS Amplify
 * Authenticator to handle user profile management events such as
 * signing in, resetting the password, etc.
 *
 * We are disabling the pre-built components and importing our own
 * custom components to handle views and logic for each state of the
 * Authenticator.
 *
 * The AWSAuthenticator wraps our custom components so that they
 * have access to all of its props. For our purposes we are utilizing:
 *
 * authState: Keeps track of the current state in our authentication
 * flow in order to display the proper custom component.
 * authData: Holds any data that is passed through during authState
 * changes.
 * onStateChange: The built in function that allows us to change
 * authState and pass along any relevant authData.
 *
 * For future changes we might want to look into creating custom
 * components for SignUp, ConfirmSignUp, etc.
 */

const Authenticator: React.FC = () => {
  return (
    <div className="Authenticator">
      <AWSAuthenticator hideDefault amplifyConfig={config}>
        <SignIn />
        <ConfirmSignIn />
        <RequireNewPassword />
        <ForgotPassword />
        <ForgotPasswordReset />
        <Loading />
      </AWSAuthenticator>
    </div>
  );
};

export default Authenticator;
